import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { getDataLayer } from "../trackingHelper";
import {
    CartLineModel,
    OrderLineModel,
    ProductInventoryDto,
    WarehouseDto
} from "@insite/client-framework/Types/ApiModels";
import { Category } from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import logger from "@insite/client-framework/Logger";
import productClickTrackingBuilder from "./productClickTrackingBuilder";

const productClickTracking = (
    product: CartLineModel | ProductContextModel | OrderLineModel,
    carouselTitle: string,
    carouselType: string,
    category: Category | undefined,
    currentPageUrl: string,
    state: ApplicationState,
    warehouses: WarehouseDto[] | undefined,
    inventory?: ProductInventoryDto,
    itemLinkClick?: string | undefined,
    parentProductId?: string | undefined,
) => {
    try {
        const dataLayer = getDataLayer();
        if (dataLayer) {
            dataLayer.push({ ecommerce: null });
            const dataLayerProductClick = productClickTrackingBuilder(
                carouselTitle, category, carouselType, currentPageUrl, product, state, inventory, parentProductId, warehouses, itemLinkClick);
            dataLayer.push(dataLayerProductClick);
        }
    } catch (error) {
        logger.debug(error);
    }
}

export default productClickTracking;